$(document).ready(function(){
  var acc = document.getElementsByClassName("Collapsible__Button");var i;
  for (i = 0; i < acc.length; i++) {acc[i].onclick = function(){ this.classList.toggle("active"); this.nextElementSibling.classList.toggle("show");}}
  $('.slider').slick({slidesToShow: 3,slidesToScroll: 1,dots: true,autoplaySpeed: 2000,infinite: true,autoplay: true,arrows: true,cssEase: 'linear',lazyLoad: 'ondemand',
    responsive: [
      {breakpoint: 1024,settings: {slidesToShow: 3,slidesToScroll: 3,infinite: true,dots: true}},
      {breakpoint: 600,settings: {slidesToShow: 2,slidesToScroll: 2}},
      {breakpoint: 480,settings: {slidesToShow: 1,slidesToScroll: 1}}
    ] 
  });
  $('.slider-bridal').slick({slidesToShow: 5,slidesToScroll: 1,dots: false,autoplaySpeed: 2000,infinite: true,autoplay: true,arrows: true,cssEase: 'linear',lazyLoad: 'ondemand',
    responsive: [
      {breakpoint: 1024,settings: {slidesToShow: 3,slidesToScroll: 3,infinite: true,dots: true }},
      {breakpoint: 600,settings: {slidesToShow: 2,slidesToScroll: 2}},
      {breakpoint: 480,settings: {slidesToShow: 1,slidesToScroll: 1}}
    ]
  });  
  $('.slider-item').slick({slidesToShow: 5,slidesToScroll: 1,infinite: true,dots: false,autoplay: false,arrows: true,infinite: true,lazyLoad: 'ondemand',
    responsive: [
      {breakpoint: 1024,settings: {slidesToShow: 3,slidesToScroll: 3,infinite: true,dots: true}},
      {breakpoint: 600,settings: {slidesToShow: 2,slidesToScroll: 2}},
      {breakpoint: 480,settings: {slidesToShow: 1, slidesToScroll: 1}}
    ]
  });
  var form = $(".Footer__Block--newsletter").detach();var newele = $(".Footer__Block:first-child");
  newele.append(form);
  
  $('head').append('<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">');
  // $('.Footer__Inner .Footer__Block:nth-child(4) ul.Linklist li.Linklist__Item:nth-child(5)').append("<span class='sizefooter'>SizeChart</span>");
  // $(document).on('click','.sizefooter', function(){
  //   $('#myModal').show();
  // })

  $('.SizeChart').click(function(){
    $('#myModal').show();
  });
  var icon = $('#closeModal')[0];
  icon.onclick = function(){
    $('#myModal').hide();
  };

  // $('.Footer__Inner .Footer__Block:nth-child(4) ul.Linklist li.Linklist__Item:nth-child(5)').append("<span class='kidssizefooter'>kidSizeChart</span>");
  // $(document).on('click','.kidssizefooter', function(){
  //   $('#myModal-kids').show();
  // })

  $('#SizeChartkid').click(function(){
    $('#myModal-kids').show();
  });
  var icon = $('#closeModalkid')[0];
  icon.onclick = function(){
    $('#myModal-kids').hide();
  };

  var icon = $('#closeModal')[0];
  icon.onclick = function(){
    $('#myModal').hide();
  }
  $('.HorizontalList--spacingTight .HorizontalList__Item:last-child .SizeSwatch').click(function(){
    $('#myModal1').show();
    $('#shopify-section-header').css({'z-index': 0});
    $('.AnnouncementBar').css({'z-index': 0});
    $('body').css({'overflow': 'hidden','background': '#000000c7'});

  });
  var icon = $('#closeModal1')[0];
  if (icon) {
    icon.onclick = function(){
      $('#myModal1').hide();
      $('#shopify-section-header').css({'z-index': '5'});
      $('.AnnouncementBar').css({'z-index': '1'});
      $('body').css({'overflow': 'auto','background': 'transparent'});
    }
  }
  
});

